/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Pick_Meta_TitleInputs */

const en_dr_pick_meta_title = /** @type {(inputs: Dr_Pick_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Room — Bystep`)
};

const id_dr_pick_meta_title = /** @type {(inputs: Dr_Pick_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Room — Bystep`)
};

/**
* | output |
* | --- |
* | "Design Room — Bystep" |
*
* @param {Dr_Pick_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_pick_meta_title = /** @type {((inputs?: Dr_Pick_Meta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Pick_Meta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_pick_meta_title(inputs)
	return en_dr_pick_meta_title(inputs)
});